import React from "react";
import { Link } from "react-router-dom";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

const skills = ["Web Development", "App Development", "Software Development", "Digital Marketing"];

export default function Founder() {
  const ref = useScrollAnimation();

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Fraunces:wght@700;900&display=swap');
        .fdr-heading { font-family: 'Fraunces', serif; }
        .fdr-body    { font-family: 'Plus Jakarta Sans', sans-serif; }
      `}</style>

      <section id="founder" className="fdr-body py-16 relative bg-gradient-to-b from-white to-blue-50 overflow-hidden">
        {/* Blobs */}
        <div className="absolute top-0 right-0 w-72 h-72 bg-blue-100/50 rounded blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-sky-100/40 rounded blur-3xl pointer-events-none" />

        <div className="max-w-5xl mx-auto px-5 md:px-10 relative">
          <div
            ref={ref}
            className="section-animate relative bg-white border border-slate-200 rounded p-8 md:p-12 flex flex-col md:flex-row gap-10 items-center overflow-hidden shadow-sm"
          >
            {/* Card inner blob */}
            <div className="absolute -top-16 -right-16 w-52 h-52 bg-blue-100/50 rounded blur-3xl pointer-events-none" />

            {/* Bottom accent line */}
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-400 to-sky-400 rounded" />

            {/* Avatar — logo image */}
            <div className="flex-shrink-0 relative">
              <div className="w-36 h-36 md:w-48 md:h-48 rounded  border border-blue-200 flex items-center justify-center">
                <img
                  src="/logo1.png"
                  alt="Nosh Infotech"
                  className="w-full h-full object-contain"
                />
              </div>
           
            </div>

            {/* Content */}
            <div className="flex-1 relative">
              <span className="inline-block text-xs font-bold text-blue-600 tracking-widest uppercase bg-blue-100 border border-blue-200 rounded px-5 py-1.5 mb-4">
                The Person Behind Nosh
              </span>

              <h2 className="fdr-heading font-black text-3xl md:text-4xl text-black mb-4 leading-tight">
                Founded by{" "}
                <span
                  style={{
                    background: "linear-gradient(135deg,#1d4ed8 0%,#0ea5e9 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                  }}
                >
                  Parveen Jangra
                </span>
              </h2>

              <p className="text-slate-500 text-sm leading-relaxed font-medium mb-6">
                With 4+ years in digital product building, Parveen started Nosh Infotech with one clear mission — to give businesses access to world-class digital solutions without the agency nonsense. Every project at Nosh gets personal attention, strategic thinking, and execution that actually moves the needle.
              </p>

              {/* Skill chips */}
              <div className="flex flex-wrap gap-2 mb-6">
                {skills.map((skill) => (
                  <span
                    key={skill}
                    className="text-xs font-semibold text-blue-600 bg-blue-50 border border-blue-200 rounded px-3 py-1"
                  >
                    {skill}
                  </span>
                ))}
              </div>

              {/* CTA buttons */}
              <div className="flex flex-wrap gap-3">
                {/* WhatsApp & mailto are external — must use <a> */}
                <a
                  href="https://wa.me/919253174295"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 bg-green-50 border border-green-200 text-green-700 text-xs font-bold px-5 py-2.5 rounded hover:bg-green-100 transition-all duration-200"
                >
                  <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.555 4.126 1.526 5.859L0 24l6.335-1.507A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.891 0-3.667-.5-5.207-1.375l-.375-.219-3.758.894.952-3.664-.244-.389A9.93 9.93 0 012 12c0-5.514 4.486-10 10-10s10 4.486 10 10-4.486 10-10 10z" />
                  </svg>
                  Say Hello
                </a>

                <a
                  href="mailto:info@noshinfotech.com"
                  className="inline-flex items-center gap-2 bg-white border border-slate-200 text-slate-500 text-xs font-semibold px-5 py-2.5 rounded hover:border-blue-300 hover:text-blue-600 transition-all duration-200"
                >
                  ✉ info@noshinfotech.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}